import { Components } from '@mui/material'

export function OverridedAutocomplete(): Components {
  return {
    MuiAutocomplete: {
      defaultProps: {
        slotProps: {
          chip: {
            size: 'small',
          },
          clearIndicator: {
            size: 'small',
          },
        },
      },
      styleOverrides: {
        groupUl: {
          margin: '0 !important',
        },
        input: {
          minWidth: 'unset !important',
        },
        root: {
          // Corrige rotação do icone em searchable
          '&.searchable .MuiAutocomplete-popupIndicator': {
            transform: 'none',
          },
        },
      },
    },
  }
}
